/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{deprecatedModule as e}from"./core/deprecate.js";import r from"./core/Logger.js";import t from"./time/TimeInterval.js";e(r.getLogger("esri.TimeInterval"),"esri.TimeInterval",{replacement:"esri.time.TimeInterval",version:"4.31",warnOnce:!0});export{t as default};
